var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_603_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H512V512H0V0Z",
    fill: "#FFDF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.934 400.003C354.247 416.842 367.665 429.219 391.396 429.219C411.331 429.219 424.066 419.255 424.066 405.488C424.066 388.99 410.982 383.147 389.039 373.549L377.011 368.388C342.292 353.597 319.228 335.067 319.228 295.895C319.228 259.811 346.722 232.342 389.689 232.342C420.279 232.342 442.271 242.988 458.118 270.864L420.653 294.92C412.404 280.129 403.505 274.302 389.689 274.302C375.597 274.302 366.665 283.242 366.665 294.92C366.665 309.354 375.605 315.197 396.247 324.137L408.275 329.289C449.154 346.819 472.234 364.69 472.234 404.87C472.234 448.187 438.206 471.918 392.508 471.918C347.826 471.918 318.959 450.625 304.834 422.717L343.934 400.003ZM173.974 404.172C181.532 417.582 188.408 428.919 204.938 428.919C220.745 428.919 230.717 422.734 230.717 398.687V235.09H278.829V399.336C278.829 449.154 249.621 471.829 206.986 471.829C168.464 471.829 146.156 451.893 134.81 427.882L173.974 404.172Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_603_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJsLogo);
export default __webpack_public_path__ + "static/media/js-logo.4922186287ea1941843e8cb1ff142f6d.svg";
export { ForwardRef as ReactComponent };